module.exports = __webpack_public_path__ + "img/BOC.df4b7581.png";